export default __webpack_public_path__ + "static/media/1819.912b4d90.png";